module.exports = function() {
  return new Worker(__webpack_public_path__ + "61479c1562936122e7b5.worker.js");
};